import { render, staticRenderFns } from "./repCreateClientForm.vue?vue&type=template&id=5345dd4c&"
import script from "./repCreateClientForm.vue?vue&type=script&lang=js&"
export * from "./repCreateClientForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports